import React from 'react';
import Layout from '@components/Layout';
import FAQ from './faq';

async function action({ token, uId, userRole, language, isMobile }) {
  return {
    title: 'FAQ',
    chunks: ['faq'],
    component: (
      <Layout>
        <FAQ
          token={token}
          UID={uId}
          language={language}
          userRole={userRole}
          isMobile={isMobile}
        />
      </Layout>
    ),
  };
}

export default action;
